import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../component/ui/button";
import { Input } from "../../component/ui/input";
import { Label } from "../../component/ui/label";
import { composeValidators, email, passwordsMustMatch, renderField, required, validatePassword } from "../../helpers/form-validations";
import { Field, Form } from "react-final-form";
import { EyeNoneIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import OTPComponent from "../../component/login/otpComponent";
import { login, resetPassword, verifyForgotPasswordToken } from "../../utils/util";
import GetEmail from "../../component/login/getEmail";
import PasswordStrengthMeter from "../../component/login/PasswordStrengthMeter";
import { useDispatch } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";

// Fix for accessibility issues. Issue # VI26-97
export const description =
  "A login page with two columns. The first column has the login form with email and password. There's a Forgot your password link and a link to sign up if you do not have an account. The second column has a cover image.";

export function ForgotPassword() {
    const navigate=useNavigate()
    const [password,setPassword]=useState("")
    const [tokenRes,setTokenRes]=useState([])
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isVerified,setIsVerified]=useState(false)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const dispatch=useDispatch()
//   const onSubmit = (values) => {
//     console.log(values); // Handle form submission here
//   };
const [isResetPassword,setIsResetPassword]=useState(false)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };


  useEffect(() => {
    // Save the isOTP state to localStorage whenever it changes
    
    localStorage.setItem('isOTPPage', isVerified);
  
   
  }, [isVerified]);

  const verifyPasswordToken = async () => {
 
    try {
         const tokenRes = await verifyForgotPasswordToken(token);
    console.log("tokemn res",tokenRes)
    if ( tokenRes &&  tokenRes?.code === 200) {
      setTokenRes(tokenRes?.data || {})
      // dispatch(alertSuccess(tokenRes?.message))
    }else{
      navigate('/');
      // dispatch(alertDanger(tokenRes?.message))
    }
  } 
  catch (error) {
    console.error('Error during login:', error);
    dispatch(alertDanger("Internal Server Error"))

    }
    
  };

  useEffect(() => {
    verifyPasswordToken();
  }, []);

  const onSubmit = async (formData) => {
 dispatch(loaderSet(true))
    const payload = {
      // email: tokenRes.email,
      password: formData.password,
      token:tokenRes?.token
     
    };

   


     
    try {

 const response=await resetPassword(payload)
 console.log("RESPONSE ",response)
      if(response && response?.code===200){
        navigate("/")
        dispatch(alertSuccess(response?.message))
        dispatch(loaderSet(false))
      }
      else{
        dispatch(alertDanger(response?.message))
        dispatch(loaderSet(false))
      }
    
     
    
    } catch (error) {
      

      // Log error for debugging
      console.error('Error during login:', error);
      dispatch(loaderSet(false))

    //   setFormErrors({ general: 'An error occurred during login. Please try again.' });
    }
  };

  const backToLoginPageFromOTPPage=()=>{
    setIsVerified(false)
    setIsResetPassword(false)
    localStorage.setItem("email",null)
    
}



  return (
    <>
      <div className="w-full grid h-[100vh] grid-cols-2 sm:grid-cols-2 md:h-[100vh] lg:grid-cols-2 lg:h-[100vh] xl:h-[100vh] 2xl:h-[100vh]">
        {/* Left side image */}
        <div className="hidden bg-muted lg:block">
          {/* <Image src="/placeholder.svg" alt="Image" width="1920" height="1080" className="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale" /> */}
        </div>

        {/* Right side login */}
        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <main className="flex  justify-center py-8 h-[100%] text-black " aria-labelledby="setup-password-heading">
                <div className="mx-auto flex flex-col w-full gap-6">
                  <div className=" flex justify-center items-center w-full">
                  <Link to="/" aria-label="Vasuki India Home" className="rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]">
                    <img src="/vasuki-logo.svg" className="w-56" alt="Vasuki India logo" />
                  </Link>
                  </div>
                  <div className=" grid gap-1 pl-10 pr-10 ">
                  <div className="flex flex-col gap-0 text-[#0D215C] pb-4">
          <h1 id="setup-password-heading" className='text-lg font-semibold'>Setup Password</h1>
          <p className='text-sm'>
          This will take some effort, Relax and then get started!
          </p>
        </div>
        <div className=" relative grid gap-2">
                      {/* <div className="flex items-center">
                        <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="password">Password</Label>
                        
                      </div>
                      <Field
                     id="password"
                     type={showPassword ? 'text' : 'password'}
                     name="password"
                      placeholder="*************"
                      value={password} // This binds the input to the password state
                      onChange={(e) => setPassword(e.target.value)} // Update password state
                      validate={composeValidators(required, validatePassword)} // Validate password
                      component={renderField} // Reuse the same renderField component
                      className="bg-white h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                        />

                     <div
                      className="absolute h-15 top-11 -right-1 flex items-center px-4 cursor-pointer"
                      onClick={togglePasswordVisibility}>
                      {showPassword ? (
                        <EyeNoneIcon className="h-5 w-5 text-black" />
                      ) : (
                        <EyeOpenIcon className="h-5 w-5 text-black" />
                      )}
                    </div> */}

<Field
  id="password"
  name="password"
  type={showPassword ? 'text' : 'password'}
  placeholder="*************"
  autoComplete="new-password"
  validate={composeValidators(required, validatePassword)}
  render={({ input, meta }) => {
    const showPasswordError = Boolean(meta?.error && (meta?.submitFailed || meta?.modified));

    return <div className="relative grid gap-2">
      <div className="flex items-center">
        <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="password">Password</Label>
      </div>
      <input
        {...input}
        type={showPassword ? 'text' : 'password'}
        value={password}
        aria-invalid={showPasswordError ? 'true' : 'false'}
        aria-describedby={showPasswordError ? 'password-error' : undefined}
        onChange={(e) => {
          input.onChange(e); // Update form state
          setPassword(e.target.value); // Also update password state
        }}
        placeholder="*************"
       className="bg-white pl-3 focus:outline-none h-9 w-full rounded-md text-base border border-[#3a5dd1] border-1  manrope-fontCss"
      />
      {showPasswordError && (
        <p id="password-error" className="text-red-700 text-sm text-left" role="alert" aria-live="assertive">&nbsp;{meta.error}</p>
      )}
      <button
        type="button"
        className="absolute h-11 top-10 right-0 flex items-center px-4 cursor-pointer rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]"
        onClick={togglePasswordVisibility}
        aria-label={showPassword ? 'Hide password' : 'Show password'}
        aria-pressed={showPassword}
        aria-controls="password"
      >
        {showPassword ? (
          <EyeNoneIcon className="h-5 w-5 text-black" />
        ) : (
          <EyeOpenIcon className="h-5 w-5 text-black" />
        )}
      </button>
    </div>;
  }}
/>




                    </div>
                    <div className=" relative grid gap-2">
                      <div className="flex items-center">
                        <Label className="text-start text-[#0D215C] font-bold text-lg" htmlFor="confirmPassword">Confirm Password</Label>
                        
                      </div>
                      <Field
                       id="confirmPassword"
                        type={showConfirmPassword ? 'text' : 'password'}
                       name="confirmPassword"
                       placeholder="*************"
                       autoComplete="new-password"
                       validate={composeValidators(required,passwordsMustMatch)} // Use the updated validatePassword
                        component={renderField} // Reuse the same renderField component
                       className="bg-white h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                        />
                     <button
                      type="button"
                      className="absolute h-11 top-10 right-0 flex items-center px-4 cursor-pointer rounded-md focus-visible:ring-2 focus-visible:ring-[#0D215C]"
                      onClick={toggleConfirmPasswordVisibility}
                      aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
                      aria-pressed={showConfirmPassword}
                      aria-controls="confirmPassword">
                      {showConfirmPassword ? (
                        <EyeNoneIcon className="h-5 w-5 text-black" />
                      ) : (
                        <EyeOpenIcon className="h-5 w-5 text-black" />
                      )}
                    </button>
                    </div>
                    <PasswordStrengthMeter password={password} />
                  <div className="flex justify-between py-4  w-full" >
                  <Button type="submit" className="w-[40%] bg-[#0D215C]" >
                      Save & Login
                    </Button>
                    {/* <div onClick={()=>setIsResetPassword(true)} to="/forgot-password" className="ml-auto inline-block text-[#0D215C] text-md font-semibold underline cursor-pointer">
                          Forgot your password?
                        </div> */}
                  </div>
                  </div>
                </div>
              </main>
            </form>
          )}
        />
       
      </div>
    </>
  );
}

export default ForgotPassword;
